var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppMenuLateral',{attrs:{"items":_vm.items}}),_c('div',{staticClass:"wbs-side-menu-page"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }